import { render, staticRenderFns } from "./LocaleChange.vue?vue&type=template&id=491e3748&scoped=true&"
import script from "./LocaleChange.vue?vue&type=script&lang=js&"
export * from "./LocaleChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e3748",
  null
  
)

export default component.exports